import {
  OdProtosWebData_MaintenanceRequest_FrequencyKind,
  OdProtosWebData_MaintenanceRequest_Kind,
} from '../graphql/athena/types/globalTypes';
import { MaintenanceRequestFields } from '../graphql/athena/types/MaintenanceRequestFields';
import { prettifyDate, protoDateToDate } from './date';

export const prettifyKind = (request: MaintenanceRequestFields) => {
  const kind = request.kind;
  if (kind === OdProtosWebData_MaintenanceRequest_Kind.HVAC) return 'HVAC';
  return kind.substring(0, 1).toUpperCase() + kind.substring(1).toLowerCase();
};

export const getFrequencyText = (request: MaintenanceRequestFields) => {
  const frequency = request.frequency;
  const kind = frequency ? frequency.frequencyKind : '';
  const amount = frequency ? frequency.frequencyAmount : 0;
  switch (kind) {
    case OdProtosWebData_MaintenanceRequest_FrequencyKind.ONE_OFF:
      return 'One Off';
    case OdProtosWebData_MaintenanceRequest_FrequencyKind.MONTH:
      const monthTag = amount === 1 ? ' month' : ' months';
      return 'Every ' + amount + monthTag;
    case OdProtosWebData_MaintenanceRequest_FrequencyKind.DAY:
      const dayTag = amount === 1 ? ' day' : ' days';
      return 'Every ' + amount + dayTag;
    case OdProtosWebData_MaintenanceRequest_FrequencyKind.WEEK:
      const weekTag = amount === 1 ? ' week' : ' weeks';
      return 'Every ' + amount + weekTag;
    default:
      return 'Could not get frequency';
  }
};

export const getDueByWeekOfText = (request: MaintenanceRequestFields) => {
  if (!request.scheduledOn) {
    return 'Could not get due by date';
  }
  const date = protoDateToDate(request.scheduledOn);
  const dayOfWeek = date.getDay();
  let monday = date;
  if (dayOfWeek !== 1) {
    // if scheduledOn is not already on a Monday, get date for the Monday of that week
    const numDaysToSubtract = Math.abs(1 - dayOfWeek);
    const newDate = date.getDate() - numDaysToSubtract;
    monday = new Date(date.setDate(newDate));
  }
  const prettified = prettifyDate(monday);
  return `Week of ${prettified}`;
};

export const prettifyCost = (request: MaintenanceRequestFields) => {
  const cents = request.costCents;
  const roundedDollarCost = Math.ceil(cents / 100);
  return `$${roundedDollarCost}`;
};
